// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledOverlay from "@awc/App/Components/Common/StyledOverlay";
import XngLoadingOverlayUtilities from "@awc/App/Components/Common/XngLoadingOverlayUtilities";
import { isMobileScreen, isPLPBreakpoint, isSmallMobileScreen, isTabletScreen, isWideScreen } from "@awc/XDL/Utilities";
import React, { FC, useEffect } from "react";
import { useDispatch } from "react-redux";

const XngUtilities: FC = () => {
    const dispatch = useDispatch();

    const handleResize = () => {
        const isSmallMobile = isSmallMobileScreen();
        const isMobileScreenValue = isMobileScreen();
        const isTabletScreenValue = isTabletScreen();
        const isPLPBreakpointValue = isPLPBreakpoint();
        const isWideScreenValue = isWideScreen();

        dispatch({
            type: "xCommon/update",
            data: {
                key: "screenFlags",
                value: {
                    isSmallMobileScreen: isSmallMobile,
                    isMobileScreen: isMobileScreenValue,
                    isTabletScreen: isTabletScreenValue,
                    isWideScreen: isWideScreenValue,
                    isPLPBreakpoint: isPLPBreakpointValue,
                },
            },
        });
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize, { passive: true });
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <>
            <XngLoadingOverlayUtilities />
            <StyledOverlay />
        </>
    );
};

export default XngUtilities;
